import React from "react";

const FormInput = ({
  label,
  type = "text",
  name,
  placeholder = "",
  value,
  onChange,
  className = "",
  options = [], // for radio or checkbox
  rows = 3,     // for textarea
}) => {
  return (
    <div className={`flex flex-col ${className}`}>
      {label && (
        <label htmlFor={name} className="text-sm text-defaultText mb-1">
          {label} <span className="text-red-500">*</span>
        </label>
      )}

      {type === "textarea" ? (
        <textarea
          name={name}
          placeholder={placeholder}
          rows={rows}
          value={value}
          onChange={onChange}
          className="w-full border-b border-[#8D8D8D] focus:outline-none resize-none"
        />
      ) : type === "radio" || type === "checkbox" ? (
        options.map((option, index) => (
          <label key={index} className="flex items-center space-x-2 mb-1 text-defaultText">
            <input
              type={type}
              name={name}
              value={option.value}
              checked={value === option.value}
              onChange={onChange}
              className="accent-[#fca311]"
            />
            <span>{option.label}</span>
          </label>
        ))
      ) : (
        <input
        type={type === "phone" ? "tel" : type}
        name={name}
        value={value}
        inputMode={type === "phone" ? "numeric" : undefined}
        placeholder={placeholder}
        onChange={(e) => {
          if (type === "phone") {
            const val = e.target.value;
            if (/^\d{0,10}$/.test(val)) {
              onChange(e);
            }
          } else {
            onChange(e);
          }
        }}
        className="w-full border-b border-[#8D8D8D] focus:outline-none"
      />
      
      )}
    </div>
  );
};

export default FormInput;
